export const WEB_SOCKET_KEY = 'websocket';
export const WEB_SOCKET_KEY_V5 = 'websocket_v5';
export const RECONNECT_INTERVAL = 1000;
export const PING_INTERVAL = 60000; // 1mins
export const PONG_INTERVAL = 10000; // 5s
